export { TicketGeneral } from "./ticket-general";
